import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";
import MainIndex from "@/views/MainIndex.vue";

const routes: Array<RouteRecordRaw> = [
  {
    path: "/",
    name: "home",
    component: MainIndex
  }
];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
});

export default router;
